import { render } from "./ReservaRecursos.vue?vue&type=template&id=3cf45e2c&scoped=true"
import script from "./ReservaRecursos.vue?vue&type=script&lang=js"
export * from "./ReservaRecursos.vue?vue&type=script&lang=js"

import "./ReservaRecursos.vue?vue&type=style&index=0&id=3cf45e2c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf45e2c"]])

export default __exports__